import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";
import { Compass } from "lucide-react";

/**
 * Friendly fallback for both unmatched routes (used as a `path: "*"`
 * element — no error thrown) and thrown route errors (used as a route
 * `errorElement`). useRouteError() is undefined in the former case.
 */
export function ErrorPage() {
  const error = useRouteError();
  const isNotFound =
    !error || (isRouteErrorResponse(error) && error.status === 404);

  const heading = isNotFound ? "404" : "Error";
  const title = isNotFound ? "Page not found" : "Something went wrong";
  const detail = isNotFound
    ? "That page doesn’t exist or may have moved."
    : isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : "An unexpected error occurred. Try reloading.";

  return (
    <div className="flex min-h-[70vh] flex-1 items-center justify-center bg-canvas px-4">
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-muted">
          <Compass className="h-7 w-7 text-ink-muted" />
        </div>
        <p className="text-6xl font-bold tracking-tight text-ink-faint">{heading}</p>
        <h1 className="mt-3 text-lg font-semibold text-ink">{title}</h1>
        <p className="mt-1 text-sm text-ink-muted">{detail}</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-indigo-700"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
